import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-payment-mode',
  templateUrl: './edit-payment-mode.component.html',
  styleUrls: ['./edit-payment-mode.component.css']
})
export class EditPaymentModeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
